import React, { useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PerformanceGrid from '../../../components/TalentMatrix/PerformanceGrid';
import { usePrecisionMatrix } from '../../../Hooks/Features/TalentMatrix/usePrecisionMatrix';
import PrecisionReportEntry from '../../../components/TalentMatrix/PrecisionReportEntry';
import CommonFilterDropdown from '../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown';
import { MultiSelect } from 'primereact/multiselect';
import { getPreviousMonths } from '../../../utils/Helper';
import PanelHeaderTemplate from '../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import { SkeletonContainer } from '../../../components/Loader/Loader';
import { useCommon } from '../../../Hooks/Common/useCommon';

const PrecisionMatrix = () => {
  const { cardObj, rankOptions, performanceOptions, precisionReport, setPrecisionReport, filterValues, setFilterValues, summaryData, loader, tagRef } = usePrecisionMatrix();
  const { getValuePermission, checkPermission } = useCommon();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

  return (
    <div ref={() => checkPermission("Precision Report", tagRef)} >
      <div ref={tagRef} id='{"data": "precision_matrix_tab"}'>
        <div className="row sk-header-row py-1">
          {/* <div className='col-md-2 col-12'>
            <MultiSelect
              className='sk-multiselect'
              placeholder='Month'
              options={getPreviousMonths(12)}
              value={filterValues?.months}
              onChange={(e) => { setFilterValues((prev) => ({ ...prev, months: e.value, isChange: true })); }}
              filter filterInputAutoFocus
              onHide={() => { if (filterValues?.isChange) { setFilterValues((prev) => ({ ...prev, apiCall: true, isChange: false })) } }}
              panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'months', options.months, (val) => setFilterValues((prev) => ({ ...prev, months: val, isChange: true })), () => { })}
            />
          </div> */}
          <div className="d-flex justify-content-end align-items-center gap-2">
            <button
              className="sk-btn-primary rounded"
              onClick={() => setFilterValues((prev) => ({ ...prev, apiCall: true }))}
              title="Refresh"
            >
              <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
            </button>
            <button
              className="sk-btn-primary rounded"
              onClick={() => setShowFiltersDrawer(true)}
              title="Filters"
            >
              <FontAwesomeIcon icon="fa-solid fa-filter" />
            </button>
          </div>
        </div>
        <div className="row mx-0">
          {
            cardObj?.map((value) => {
              return <div className="col-lg-3 col-sm-6 col-12 mt-1">
                <div className="sk-card-container w100" style={{ borderTop: `3px solid #059669` }}>
                  <div className="d-flex gap-2">
                    <div className="w20 d-flex justify-content-center align-items-center"><span className='rounded d-flex align-items-center p-2' style={{ background: "#ecfdf5 " }}><FontAwesomeIcon icon={value?.icon} style={{ width: "25px", height: "25px", color: "#059669" }} /></span>
                    </div>
                    <div className='c-pointer' onClick={() => setPrecisionReport({ show: true, lead: "" })}>
                      <span style={{ fontSize: "14px", fontWeight: "500" }}>{value?.label}</span>
                      <h4 style={{ fontWeight: "600" }}>{value?.render(summaryData?.cardsData?.[0]?.[value?.key])}</h4>
                    </div>
                  </div>
                </div>
              </div>
            })
          }
        </div>
        <div className='row mx-0 py-3 '>
          <div className='col-6'>
            <div className='shadow-sm border rounded' style={{ width: '100%' }}>
              <div className='border-bottom py-2 px-2'>
                <div className="fw-bold text-uppercase">Rating Distribution</div>
              </div>
              <div className='p-2' style={{ height: "340px" }}>
                {
                  loader ? <SkeletonContainer /> :
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={rankOptions}
                    />
                }
              </div>

            </div>
          </div>
          <div className='col-6'>
            <div className='shadow-sm border rounded' style={{ width: '100%' }}>
              <div className='border-bottom py-2 px-2'>
                <div className="fw-bold text-uppercase">Lead performance averages</div>
              </div>

              <div className='p-2' style={{ height: "340px" }}>
                {
                  loader ? <SkeletonContainer /> :
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={performanceOptions}
                    />
                }
              </div>
            </div>
          </div>
        </div>
        <div className='row mx-0'>
          <div className='col-12'>
            <PerformanceGrid precisionReport={precisionReport} setPrecisionReport={setPrecisionReport} rowData={summaryData?.HeatMapData || []} loader={loader} />
          </div>
        </div>

        {precisionReport?.show && <PrecisionReportEntry precisionReport={precisionReport} setPrecisionReport={setPrecisionReport} filterValues={filterValues} />}
      </div>

      {/* Right Panel Filters Drawer */}
      <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
        <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
          <div className="sk-drawer-header">
            <h5 className="sk-drawer-title">Filters</h5>
            <div className="d-flex align-items-center gap-2">
              <button className="sk-drawer-clear-btn" onClick={() => {
                setFilterValues({
                  ...filterValues,
                  months: [],
                  users: [],
                  precision_lead: null,
                  isChange: true
                });
              }}>Clear All</button>
              <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                <FontAwesomeIcon icon="fa-solid fa-xmark" />
              </button>
            </div>
          </div>
          <div className="sk-drawer-body">
            <div className='d-flex flex-column gap-4'>
              {/* Month Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Month</div>
                <MultiSelect
                  placeholder='Month'
                  options={getPreviousMonths(12)}
                  value={filterValues?.months}
                  onChange={(e) => { setFilterValues((prev) => ({ ...prev, months: e.value, isChange: true })); }}
                  filter filterInputAutoFocus
                  onHide={() => { if (filterValues?.isChange) { setFilterValues((prev) => ({ ...prev, apiCall: true, isChange: false })) } }}
                  panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'months', options.months, (val) => setFilterValues((prev) => ({ ...prev, months: val, isChange: true })), () => { })}
                  className="sk-input-dd w-100"
                />
              </div>

              {/* Core Filters */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Core Filters</div>
                <CommonFilterDropdown
                  fields={[
                    { key: "users", label: "Users", col: 12 },
                    { key: "precision_lead", label: "Leads", col: 12, type: "dropdown", isHide: getValuePermission("precision_entry_lead_dropdown") }
                  ]}
                  filterValues={filterValues}
                  setFilterValues={setFilterValues} />
              </div>
            </div>
          </div>
          <div className="sk-drawer-footer">
            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
              setFilterValues((prev) => ({ ...prev, apiCall: true }));
              setShowFiltersDrawer(false);
            }}>Apply Filters</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrecisionMatrix
